import * as React from 'react';
export const SBSvg = React.forwardRef(function SBSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement(
      'g',
      {
        fill: 'none',
        fillRule: 'evenodd',
        transform: 'translate(0 2)',
      },
      /*#__PURE__*/ React.createElement('rect', {
        width: 16,
        height: 12,
        fill: '#FCD669',
        rx: 2,
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#217AB7',
        d: 'M0 9.991V2a2 2 0 0 1 2-2h12L.183 10.832A2.011 2.011 0 0 1 0 9.992Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#FFF',
        fillRule: 'nonzero',
        d: 'M4 2.5a.5.5 0 1 1 1 0 .5.5 0 0 1-1 0Zm-2 2a.5.5 0 1 1 1 0 .5.5 0 0 1-1 0Zm2 0a.5.5 0 1 1 1 0 .5.5 0 0 1-1 0ZM2.067 2.75a.5.5 0 1 1 .866-.5.5.5 0 0 1-.866.5ZM3 3.5c0-.276.22-.5.49-.5a.489.489 0 0 1 .441.245.508.508 0 0 1 0 .51.489.489 0 0 1-.44.245A.495.495 0 0 1 3 3.5Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#159570',
        d: 'M15.817 1.168c.117.255.183.54.183.84V10a2 2 0 0 1-2 2H2L15.817 1.168Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#A68527',
        fillOpacity: 0.1,
        fillRule: 'nonzero',
        d: 'M16 2.009c0-.3-.066-.586-.183-.841l-.82.752A1 1 0 0 0 14 1h-3.09L12 0h2a2 2 0 0 1 2 2v.009ZM0 10c0 .3.066.585.183.84l.82-.751a1 1 0 0 0 .997.92h3.09l-1.09 1H2a2 2 0 0 1-2-2V10Z',
      }),
    ),
  );
});
SBSvg.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
};
export var SB = {
  category: 'flag',
  colorable: false,
  name: 'SB',
  svg: SBSvg,
};
